import React from "react";
import { Modal } from "rsuite";

import TextContent from "../text/textCotent";
import RadioContent from "../radio/radioContent";
import HtmlContent from "../html-content/htmlContent";
import CheckboxContent from "../checkbox/checkboxContent";

import "./modalContent.scss";

const ModalContent = ({
  modal,
  updateInfo,
  handleEdit,
  activeModal,
  handleClose,
  getAnswerValueByName,
  updateAnswer,
}) => {
  const {
    id,
    title,
    name,
    style,
    size,
    type,
    options,
    content,
    body,
    default_value: defaultValue,
  } = modal;
  let view = null;
  if (modal.type === "radio") {
    view = (
      <RadioContent
        id={id}
        name={name}
        style={style}
        getAnswerValueByName={getAnswerValueByName}
        updateAnswer={updateAnswer}
        type={type}
        options={options}
        content={content}
        defaultValue={defaultValue}
      />
    );
  } else if (type === "text") {
    view = (
      <TextContent
        name={name}
        style={style}
        getAnswerValueByName={getAnswerValueByName}
        updateAnswer={updateAnswer}
        type={type}
        options={options}
        content={content}
        defaultValue={defaultValue}
      />
    );
  } else if (type === "checkbox") {
    view = (
      <CheckboxContent
        name={name}
        style={style}
        getAnswerValueByName={getAnswerValueByName}
        updateAnswer={updateAnswer}
        type={type}
        options={options}
        content={content}
        defaultValue={defaultValue}
      />
    );
  } else if (type === "html") {
    view = <HtmlContent key={id} content={body} style={style} />;
  }

  return (
    <div className={`${style ? style : ""}`}>
      <Modal
        open={activeModal(name)}
        onClose={handleClose}
        size={size}
        keyboard={true}
      >
        <Modal.Header className="mt-2">
          {title ? (
            <h6 className="tar" style={{ fontSize: "0.9rem" }}>
              {title}
            </h6>
          ) : (
            ""
          )}
        </Modal.Header>
        <div className="mt-1">{view}</div>
        <Modal.Footer className="mt-2" style={{ textAlign: "center" }}>
          <div
            className={
              modal?.buttons?.length > 1 ? "modal_buttons_container" : ""
            }
          >
            {modal?.buttons?.map((item) => {
              if (item.type === "updateInfo") {
                return (
                  <button
                    className={`btn-green ${item.class ?? ""}`}
                    style={item.style ?? null}
                    onClick={(event) => updateInfo(event, name)}
                  >
                    {item.title}
                  </button>
                );
              } else if (item.type === "handleEdit") {
                return (
                  <button
                    onClick={(event) => handleEdit()}
                    className={`btn-green-secondary ${item.class ?? ""}`}
                    style={item.style ?? null}
                  >
                    {item.title}
                  </button>
                );
              } else {
                return null;
              }
            })}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalContent;
